export class AuthModel{
    constructor(
       public Password : string = '',
    ){}
}